import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('ReportAccesses');

export const reportAccessQueries = {
  selectAll: baseQuery
};
